import React from "react";

const positions = (formattedCapital) => [
  ["Current Position", "Existing portfolio", "The organisation continues under its current controls and financial protection."],
  ["Economically Optimal Portfolio", formattedCapital, "Capital required to implement the economically justified portfolio before applying a budget limit."],
];

export default function CapitalAllocationPositionTable({ formattedCapital }) {
  return (
    <div className="mt-6">
      <table className="hidden w-full table-fixed border-collapse text-left text-sm sm:table">
        <thead><tr className="border-y border-slate-200 text-xs uppercase tracking-[0.1em] text-slate-500">
          <th scope="col" className="w-1/4 px-4 py-3 font-semibold">Portfolio Position</th>
          <th scope="col" className="w-1/4 px-4 py-3 font-semibold">Capital Requirement</th>
          <th scope="col" className="px-4 py-3 font-semibold">Board Interpretation</th>
        </tr></thead>
        <tbody>{positions(formattedCapital).map(([position, capital, interpretation]) => (
          <tr key={position} className="border-b border-slate-200 align-top">
            <th scope="row" className="px-4 py-4 font-semibold text-slate-900">{position}</th>
            <td className="px-4 py-4 font-medium text-slate-800">{capital}</td>
            <td className="px-4 py-4 leading-6 text-slate-600">{interpretation}</td>
          </tr>
        ))}</tbody>
      </table>
      <div className="space-y-3 sm:hidden">{positions(formattedCapital).map(([position, capital, interpretation]) => (
        <article key={position} className="rounded-lg border border-slate-200 p-4">
          <h4 className="font-semibold text-slate-900">{position}</h4>
          <dl className="mt-3 space-y-3 text-sm"><div><dt className="text-xs font-semibold uppercase tracking-wide text-slate-500">Capital Requirement</dt><dd className="mt-1 font-medium text-slate-800">{capital}</dd></div><div><dt className="text-xs font-semibold uppercase tracking-wide text-slate-500">Board Interpretation</dt><dd className="mt-1 leading-6 text-slate-600">{interpretation}</dd></div></dl>
        </article>
      ))}</div>
    </div>
  );
}
